import { render } from "./tshirt.vue?vue&type=template&id=0b7d7b8f"
import script from "./tshirt.vue?vue&type=script&lang=js"
export * from "./tshirt.vue?vue&type=script&lang=js"

import "./tshirt.vue?vue&type=style&index=0&id=0b7d7b8f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__